<template>
    <div class="flex-1 flex">
        <div class="w-24 text-blue-600 font-semibold pt-px">
            Signer #{{ index + 1 }}
        </div>

        <div class="flex-1 flex flex-col sm:flex-row pl-4">
            <div class="sm:col-gap-2 sm:w-2/5">
                <input-text
                    :name="'recipients' + index_for_array + '[name]'"
                    v-model="recipient.name"
                    label="Name"
                    placeholder="Name"
                    :read_only="recipient.completed_at"
                />
            </div>

            <div class="sm:col-gap-2 sm:w-3/5">
                <input-text
                    :name="'recipients' + index_for_array + '[email]'"
                    v-model="recipient.email"
                    label="Email"
                    placeholder="Email"
                    :read_only="recipient.completed_at"
                />
            </div>

            {{ recipient.local_id }}
        </div>
    </div>
</template>

<script>
export default {
    props: {
        recipient: { default: () => ({}) },
        index: {},
    },

    computed: {
        index_for_array() {
            return this.index != null ? '[' + (this.index + 1) + ']' : '';
        },
    },
}
</script>
